<template>
  <v-app>
    <div :class="{ color_bg: status }"></div>
    <AppBar />
    <Drawer />
    <ResetPasswordDialog />
    <v-main style="z-index: 2; position: relative; height: 100vh">
      <v-fade-transition mode="out-in">
        <router-view />
      </v-fade-transition>
    </v-main>
    <SnackBar />
  </v-app>
</template>

<script>
import { mapState } from 'vuex'
import AppBar from '@/components/Nav/AppBar'
import Drawer from '@/components/Nav/Drawer'
import SnackBar from '@/components/Widgets/SnackBar'
import ResetPasswordDialog from '@/components/Dialogs/ResetPasswordDialog'

export default {
  name: 'App',
  metaInfo: {
    title: 'Login',
    titleTemplate: 'Asiabots Lab - %s'
  },
  components: { AppBar, Drawer, SnackBar, ResetPasswordDialog },
  data() {
    return {
      active_timer: null,
      active: 0,
      resetActiveInSeconds: 900
    }
  },
  computed: {
    ...mapState(['auth']),
    status() {
      return this.auth.status
    },
    post_login_action_required() {
      return this.auth.post_login_action_required
    }
  },
  methods: {
    initActiveTime() {
      this.active = 0

      document.addEventListener('mousedown', () => {
        this.active = 0
      })

      this.active_timer = setInterval(() => {
        this.active = this.active + 1
        if (this.active > this.resetActiveInSeconds) {
          this.resetActiveTime()
          if (this.status) this.$store.dispatch('logoutUser')
        }
      }, 1000)
    },
    resetActiveTime() {
      document.removeEventListener('mousedown', null)
      clearInterval(this.active_timer)
    }
  },
  watch: {
    status() {
      if (this.status) this.initActiveTime()
      else this.resetActiveTime()
    }
  },
  mounted() {
    // If login, check wether the token is still valid
    this.$store.dispatch('verifyToken')
    setInterval(() => {
      if (this.status && !this.post_login_action_required) this.$store.dispatch('verifyToken')
    }, 60000)

    if (this.status) this.initActiveTime()
  }
}
</script>

<style scoped>
.color_bg {
  position: fixed !important;
  top: 0px !important;
  left: 0px !important;
  width: 100% !important;
  height: 100% !important;
  z-index: 1 !important;
  background: #f5f5f5 !important;
  /* background: linear-gradient(
    150deg,
    #F5F5F5  0%,
    rgba(205, 47, 47, 1) 100%
  ) !important; */
}
</style>

<style>
@import url('https://fonts.googleapis.com/css2?family=Open+Sans:wght@300;400;500;600;700&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Nunito+Sans:wght@300;400;500;600;700&display=swap');
* {
  font-family: 'Open Sans', sans-serif;
}

/* v-dialog */
.v-dialog {
  border-radius: 24px !important;
}

.dialog-title {
  font-weight: 700;
  font-size: 24px;
  line-height: 116%;
}

.round-btn {
  font-weight: 600;
  font-size: 14px !important;
  line-height: 24px;
}

/* v-btn */
.v-btn {
  min-width: 0 !important;
}

.v-btn__content {
  letter-spacing: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 24px;
}

/* v-text-field */
.v-text-field--solo.shadow-textfield > .v-input__control > .v-input__slot {
  background-color: #f5f5f5 !important;
}

.v-text-field.shadow-textfield.v-text-field--solo:not(.v-text-field--solo-flat) > .v-input__control > .v-input__slot {
  box-shadow: none !important;
}

.v-text-field--outlined.v-input--dense.v-text-field--outlined:not(.edit-text-field) > .v-input__control > .v-input__slot {
  min-height: 0px !important;
  height: 36px;
}

.v-text-field--outlined.v-input--dense.v-text-field--outlined > .v-input__control > .v-input__slot > .v-text-field__slot > .v-label {
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
}

.v-text-field--outlined fieldset {
  border: 1px solid rgba(0, 0, 0, 0.2) !important;
}

/* search bar */
.v-text-field--solo > .v-input__control > .v-input__slot {
  background-color: #f5f5f5 !important;
}

.v-text-field.v-text-field--solo:not(.v-text-field--solo-flat) > .v-input__control > .v-input__slot {
  box-shadow: none !important;
}

.v-select__selection,
.v-text-field .v-input__control input {
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: 0.1px;
}

/* tooltip */
.v-tooltip__content {
  opacity: 1 !important;
}

.tooltip-color {
  font-weight: 400;
  font-size: 14px !important;
  line-height: 20px !important;
  letter-spacing: 0.1px;
  color: #ffffff !important;
  background: rgba(0, 0, 0, 0.6) !important;
  background-color: rgba(0, 0, 0, 0.6) !important;
  border-color: rgba(0, 0, 0, 0.6) !important;
  border-radius: 8px !important;
  padding: 4px 12px !important;
}

.tooltip-top.tooltip-color::before {
  border-top: solid 0.5rem rgba(0, 0, 0, 0.6);
}

.tooltip-top::before {
  border-right: solid 6px transparent;
  border-left: solid 6px transparent;
  transform: translateX(-50%);
  position: absolute;
  z-index: -21;
  content: '';
  top: 100%;
  left: 50%;
  height: 0;
  width: 0;
  border-top: solid 6px rgba(0, 0, 0, 0.9);
}

/* vue tag input */

.label-card {
  border: 1px solid #c7c7c7 !important;
  border-radius: 8px !important;
  overflow: auto;
}

/* 0.5px line  */
.half-1px-line-btm::after {
  content: '';
  position: absolute;
  width: 200%;
  height: 200%;
  top: 0;
  left: 0;
  transform-origin: 0 0;
  border-width: 1px;
  border-color: #828282;
  border-style: solid;
  transform: scale(0.5, 0.5);
  border-radius: 1px;
  box-sizing: border-box;
  pointer-events: none;
  border-width: 0;
  border-bottom-width: 1px;
}

.half-1px-line-top::after {
  content: '';
  position: absolute;
  width: 200%;
  height: 200%;
  top: 0;
  left: 0;
  transform-origin: 0 0;
  border-color: #828282;
  border-style: solid;
  transform: scale(0.5, 0.5);
  border-radius: 1px;
  box-sizing: border-box;
  pointer-events: none;
  border-width: 0;
  border-top-width: 1px;
}

/* general */

.project-title {
  color: #211f20;
  font-family: 'Nunito Sans';
  font-size: 20px;
  font-weight: 700;
  line-height: 24px;
}

.page-title {
  color: #1b1b1b;
  font-size: 34px;
  font-weight: 700;
  line-height: 24px;
}

.content-card {
  border-radius: 30px !important;
}

.result-card {
  border-radius: 0px !important;
}

.rounded-corner {
  border-radius: 8px !important;
}

.one-line-ellipsis {
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.table-title {
  font-weight: 700;
  font-size: 20px;
  line-height: 125%;
  color: #1b1b1b;
}

.result-title {
  font-weight: 700 !important;
  font-size: 20px !important;
  line-height: 125% !important;
  color: #808080;
}

.input-title {
  font-weight: 600;
  font-size: 14px;
  line-height: 24px;
  color: #1b1b1b;
}

.sub-title {
  height: 3rem;
  font-weight: 700 !important;
  font-size: 20px !important;
  line-height: 125% !important;
  color: #1b1b1b;
}

.desc-text {
  color: #828282;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: 0.1px;
}

.status-chip {
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  text-align: center;
  letter-spacing: 0.1px;
  padding: 4px 6px;
  border-radius: 4px;
}

/* width */
::-webkit-scrollbar {
  width: 10px;
  border-radius: 8px;
}

/* Track */
::-webkit-scrollbar-track {
  border-radius: 8px;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: rgb(187, 187, 187);
  border-radius: 8px;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: #808080;
}
</style>
